$(document).on('click', '#add-to-cart-property', function (e) {
  if (!$('#checkbox-backorder-new').is(':checked')) {
    e.preventDefault();
    $('.alert-message-backorder').show();
    return;
  }

  $('#add-to-cart-property').text('Adding...');
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      id: $variantPropertyBackorder,
      quantity: 1,
      properties: {
        'Backorder': "I acknowledge that this item is currently on backorder and will not ship immediately."
      }
    },
    dataType: 'json',
    success: function() {
      $('#add-to-cart-property').text('Add to Cart');
    },
    error: function(XMLHttpRequest, textStatus, errorThrown) {
      console.log('Error al agregar los productos al carrito');
    }
  });
});

$(document).on('change', '#checkbox-backorder-new', function () {
  if ($(this).is(':checked')) {
    $('.alert-message-backorder').hide();
  }
});
